import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BookItem from "../library/BookItem";
import { ArrowLeftButtonSvg, ArrowRightButtonSvg } from "../images/Svg";

const Wrapper = styled.div``;

const ItemsWrapper = styled.div`
    max-width: 100%;
    padding: 1%;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
`;

const ItemStyled = styled.div`
    display: inline-block;
    margin: 0 7px;
    width: 270px;
    height: 270px;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    border: 4px solid transparent;

    @media (max-width: 780px) {
        height: 340px;
    }

    img {
        //border-radius: 8px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &.selected {
        border: 4px solid #ffc43d;
    }

    .info {
        top: 34px;
    }
`;

const ArrowsWrapper = styled.div`
    display: grid;
    grid-gap: 18px;
    grid-template-columns: repeat(2, 30px);
    justify-content: center;
    margin-right: 0;
`;

const ArrowItemStyled = styled.div`
    border-radius: 10px;
    background: #ffa927;

    display: inline-flex;
    padding: 10px;
    align-items: flex-start;
    gap: 10px;

    cursor: pointer;

    margin-top: 15px;

    &:hover {
        background: #ffc43d;
    }

    &.hide {
        pointer-events: none;
        background: #d2d2d7a3;

        &:hover {
            background: #d2d2d7a3;
        }
    }
`;

const MobileSlider = ({ visibleItemIndex, setVisibleItemIndex, bookPreviewHandle, items, lang, langData, lastSeen }) => {
    const divRefs = useRef([]);

    useEffect(() => {
        if (visibleItemIndex !== 0) {
            if (divRefs.current[visibleItemIndex]) {
                divRefs.current[visibleItemIndex].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
    }, [visibleItemIndex, items]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const visibleDiv = entry.target;
                        const index = parseInt(visibleDiv.getAttribute("data-index"), 10);
                        if (visibleItemIndex < index) {
                            setVisibleItemIndex(index);
                        }
                    }
                });
            },
            {
                root: document.querySelector("#itemsWrapper"),
                threshold: 0.5
            }
        );

        divRefs.current.forEach((div) => {
            if (div) observer.observe(div);
        });

        return () => {
            divRefs.current.forEach((div) => {
                if (div) observer.unobserve(div);
            });
        };
    }, []);

    let showLastArrow = visibleItemIndex < items.length - 1;
    let showFirstArrow = !!visibleItemIndex;

    const isRtl = lang === "he" || lang === "ar";

    return (
        <Wrapper>
            <ItemsWrapper id="itemsWrapper">
                {items.map((item, itemIndex) => {
                    const isLastSeen = lastSeen?._id === item._id;

                    return (
                        <ItemStyled
                            key={item._id}
                            data-index={itemIndex}
                            ref={(el) => (divRefs.current[itemIndex] = el)}
                            className={visibleItemIndex === itemIndex ? "in-view" : ""}
                        >
                            <BookItem
                                isLastSeen={isLastSeen}
                                lang={lang}
                                langData={langData}
                                item={item}
                                selecteBook={(book) => bookPreviewHandle(book)}
                            />
                        </ItemStyled>
                    );
                })}
            </ItemsWrapper>
            <ArrowsWrapper>
                <ArrowItemStyled
                    className={showFirstArrow ? "show" : "hide"}
                    tabIndex="0"
                    aria-label={langData.arias.next}
                    role="button"
                    onClick={() => {
                        setVisibleItemIndex(visibleItemIndex - 1);
                    }}
                >
                    {isRtl ? <ArrowRightButtonSvg /> : <ArrowLeftButtonSvg />}
                </ArrowItemStyled>
                <ArrowItemStyled
                    className={showLastArrow ? "show" : "hide"}
                    tabIndex="0"
                    aria-label={langData.arias.prev}
                    onClick={() => {
                        setVisibleItemIndex(visibleItemIndex + 1);
                    }}
                >
                    {isRtl ? <ArrowLeftButtonSvg /> : <ArrowRightButtonSvg />}
                </ArrowItemStyled>
            </ArrowsWrapper>
        </Wrapper>
    );
};

export default MobileSlider;
